import styled from "@emotion/styled";
import React from "react";
import UI from "@mile-meeting/mile-ui";

const TimeTableSkeleton: React.FC = () => {
  return (
    <MeetingRoomReservationListContainer>
      <MeetingRoomListItemContainer>
        <div style={{ width: "100%", position: "absolute", top: 224, left: 0 }}>
          <UI.Loading.Skeleton width="100%" height="56px" />
        </div>
      </MeetingRoomListItemContainer>
      <MeetingRoomListItemContainer>
        <div style={{ width: "100%", position: "absolute", top: 280, left: 0 }}>
          <UI.Loading.Skeleton width="100%" height="112px" />
        </div>
      </MeetingRoomListItemContainer>
      <MeetingRoomListItemContainer>
        <div style={{ width: "100%", position: "absolute", top: 224, left: 0 }}>
          <UI.Loading.Skeleton width="100%" height="56px" />
        </div>
      </MeetingRoomListItemContainer>
      <MeetingRoomListItemContainer>
        <div style={{ width: "100%", position: "absolute", top: 194, left: 0 }}>
          <UI.Loading.Skeleton width="100%" height="142px" />
        </div>
      </MeetingRoomListItemContainer>
      <MeetingRoomListItemContainer>
        <div style={{ width: "100%", position: "absolute", top: 168, left: 0 }}>
          <UI.Loading.Skeleton width="100%" height="112px" />
        </div>
      </MeetingRoomListItemContainer>
      <MeetingRoomListItemContainer>
        <div style={{ width: "100%", position: "absolute", top: 280, left: 0 }}>
          <UI.Loading.Skeleton width="100%" height="168px" />
        </div>
      </MeetingRoomListItemContainer>
      <MeetingRoomListItemContainer>
        <div style={{ width: "100%", position: "absolute", top: 224, left: 0 }}>
          <UI.Loading.Skeleton width="100%" height="112px" />
        </div>
      </MeetingRoomListItemContainer>
    </MeetingRoomReservationListContainer>
  );
};

export default React.memo(TimeTableSkeleton);

export const MeetingRoomReservationListContainer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  left: 0;
  top: 8px;
  gap: 32px;
  justify-content: center;
`;

export const MeetingRoomListItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  position: relative;

  min-width: 100px;
  max-width: 280px;
`;
